const firebaseConfig = {
    apiKey: "AIzaSyDqoSfVJDWLKrFa1dYB2U7eLhx4Wvv9DpY",
    authDomain: "test-plus-7232c.firebaseapp.com",
    projectId: "test-plus-7232c",
    storageBucket: "test-plus-7232c.appspot.com",
    messagingSenderId: "1033090410293",
    appId: "1:1033090410293:web:7b28b9455731a53ae88e7c"
  };
export default firebaseConfig